import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-home-slider',
  templateUrl: './home-slider.component.html',
  styleUrls: ['./home-slider.component.scss']
})
export class HomeSliderComponent implements OnInit {
  newConfig:SwiperConfigInterface;
  constructor(public  navigation:NavigationService) { 
    this.newConfig = {
      direction: 'horizontal',
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      navigation: false,
      pagination: true,
      autoplay:true
    };
  }

  ngOnInit(): void {
    
  }

  scrollToElement(id:string){
    this.navigation.elementId = id;
    this.navigation.scrollToElement();
    return false;
  }

}
